import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

interface IMenuItem {
    type: string; // Possible values: link/dropDown/icon/separator/extLink
    name?: string; // Used as display text for item and title for separator type
    state?: string; // Router state
    icon?: string; // Material icon name
    tooltip?: string; // Tooltip text
    disabled?: boolean; // If true, item will not be appeared in sidenav.
    sub?: IChildItem[]; // Dropdown items
    badges?: IBadge[];
    allowed?: string[];
}

interface IChildItem {
    type?: string;
    name: string; // Display text
    state?: string; // Router state
    icon?: string;
    allowed?: string[];
    sub?: IChildItem[];
}

interface IBadge {
    color: string; // primary/accent/warn/hex color codes(#fff000)
    value: string; // Display text
}

@Injectable()
export class NavigationService {
    constructor() {
    }

    defaultMenu: IMenuItem[] = [
        {
            name: 'DASHBOARD',
            type: 'link',
            tooltip: 'Dashboard',
            icon: 'dashboard',
            state: 'dashboard',
            allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant', 'Billing']
        },
        {
            name: 'Rentals',
            type: 'dropDown',
            tooltip: 'Rentals',
            icon: 'meeting_room',
            state: 'rentals',
            allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant', 'Billing'],
            sub: [
                {
                    name: 'Properties',
                    state: 'properties',
                    allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant', 'Billing']
                },
                {
                    name: 'Tenants',
                    state: 'tenants',
                    allowed: ['ADMIN', 'Property Manager', 'Director']
                },
                {
                    name: 'Landlords',
                    state: 'landlords',
                    allowed: ['ADMIN', 'Director']
                },
                {
                    name: 'Bulk SMS',
                    state: 'bulk',
                    // TODO: Get the correct permissions
                    allowed: ['ADMIN', 'Director', 'Property Manager']
                },
                /*{
                    name: 'Outstanding balances',
                    state: 'outstandingbalances',
                    allowed: ['ADMIN', 'Property Manager', 'Director']
                }*/
            ]
        },
        {
            name: 'Leasing',
            type: 'dropDown',
            tooltip: 'Leasing',
            icon: 'folder_shared',
            state: 'leases',
            allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant'],
            sub: [
                {
                    name: 'Vacant', state: 'listings',
                    allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant']
                },
                {
                    name: 'Occupied',
                    state: 'occupied',
                    allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant']
                },
                {
                    name: 'Applicants',
                    state: 'applicants',
                    allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant']
                },
                {
                    name: 'Lease Renewals',
                    state: 'renewals',
                    allowed: ['ADMIN', 'Property Manager', 'Director']
                }
            ]
        },
        {
            name: 'Accounting',
            type: 'dropDown',
            tooltip: 'Accounting',
            icon: 'show_chart',
            state: 'accounting',
            allowed: ['ADMIN', 'Director', 'Accountant', 'Property Manager'],
            sub: [
                {
                    name: 'Chart of Accounts',
                    state: 'chart-of-accounts',
                    allowed: ['ADMIN', 'Director', 'Property Manager', 'Accountant'],
                },
                {
                    name: 'Bills',
                    state: 'bills',
                    allowed: ['ADMIN', 'Director', 'Accountant', 'Property Manager'],
                },
                {
                    name: 'Credit Notes',
                    state: 'credit-notes',
                    allowed: ['ADMIN', 'Director', 'Accountant', 'Property Manager'],
                },
                {
                    name: 'Company Accounts',
                    state: 'company-accounts',
                    allowed: ['ADMIN', 'Director2', 'Accountant2', 'Property Manager2'],
                }
            ]
        },
        {
            name: 'Maintenance',
            type: 'dropDown',
            tooltip: 'Maintenance',
            icon: 'calendar_view_day',
            state: 'maintenance',
            allowed: ['ADMIN', 'Property Manager', 'Director'],
            sub: [
                {
                    name: 'Work Order',
                    state: 'workorder',
                    allowed: ['ADMIN', 'Property Manager', 'Director']
                }
            ]
        },
        {
            name: 'Reports',
            type: 'link',
            tooltip: 'Reports',
            icon: 'list',
            state: 'reports/list',
            allowed: ['ADMIN', 'Property Manager', 'Director', 'Accountant']
        }
    ];

    // Icon menu TITLE at the very top of navigation.
    // This title will appear if any icon type item is present in menu.
    iconTypeMenuTitle: string = 'Frequently Accessed';
    // sets iconMenu as default;
    menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
    // navigation component has subscribed to this Observable
    menuItems$ = this.menuItems.asObservable();

    // Customizer component uses this method to change menu.
    // You can remove this method and customizer component.
    // Or you can customize this method to supply different menu for
    // different user type.
    publishNavigationChange(menuType: string) {
        this.menuItems.next(this.defaultMenu);
    }
}
